import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams, findUrlBiId } from '@/store/modules/rank-zone/Helper'
// eslint-disable-next-line no-unused-vars
import Url from '../../../features/reports/rank-zone/url/Url'

export const types = {
  ADD_URL_DATA: 'rank-zone/ADD_URL_DATA',
  RESET_URLS_DATA: 'rank-zone/RESET_URLS_DATA',
  ADD_URLS_KEYWORDS_DATA: 'rank-zone/ADD_URLS_KEYWORDS_DATA',
  ADD_URLS_TOTALS_DATA: 'rank-zone/ADD_URLS_TOTALS_DATA'
}

const state = {
  urls: [],
  unfiltered_totals: {}

}

const mutations = {
  [ types.ADD_URL_DATA ]: function (state, payload) {
    state.urls = payload
  },
  [ types.RESET_URLS_DATA ]: function (state) {
    state.urls = []
    state.unfiltered_totals = {}
  },
  [ types.ADD_URLS_KEYWORDS_DATA ]: function (state, { keywords, urlId }) {
    const url = findUrlBiId(state.urls, urlId)
    if (url) {
      url.children = keywords
    }
  },
  [ types.ADD_URLS_TOTALS_DATA ]: function (state, payload) {
    state.unfiltered_totals = payload
  }
}

const loadUrlData = async function (clientId, filters) {
  const msv = JSON.parse(localStorage.getItem('msv')) || {}
  filters.msv = msv[clientId] || 1
  if (filters && filters.advancedFilters) {
    const params = convertAdvancedOptionsToURLParams(filters)
    return httpService.get(`/reports/rankzone-report/url/${clientId}`, { params: params }, { encode: false })
  }
  return httpService.get(`/reports/rankzone-report/url/${clientId}`, { params: filters })
}

const actions = {
  getUrlData: async function ({ commit, dispatch }, { clientId, filters }) {
    const response = await loadUrlData(clientId, filters)
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_URL_DATA, response.data.urls)
    commit(types.ADD_URLS_TOTALS_DATA, response.data[ 'unfiltered_totals' ])

    return response
  },
  resetData ({ commit }) {
    commit(types.RESET_URLS_DATA)
  },
  /**
   * set keywords for expanded row in table
   * @param payload received from {@link getKeywordsByUrlIdData()}
   */
  setKeywords ({ commit, dispatch }, payload) {
    commit(types.ADD_URLS_KEYWORDS_DATA, payload)
  }
}

/**
 * Store keep data for {@link Url} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
